import { render } from "./Account_settings.vue?vue&type=template&id=21ad31ba"
import script from "./Account_settings.vue?vue&type=script&lang=js"
export * from "./Account_settings.vue?vue&type=script&lang=js"

import "./Account_settings.vue?vue&type=style&index=0&id=21ad31ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__